import React, { useState, useEffect, useRef } from 'react';
import { Container, Grid } from '@material-ui/core';
import { Formik } from 'formik';
import { LOGOUT } from 'ConstComponents';
import { Select as SELECT, Update as UPDATE } from 'Components/Api/ManuSubManuUserAccess';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const MainManuSubManuAccess = () => {
    const classes = commonStyle();
    const formRef = useRef();
    const [itemList, setItemList] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [pendingChanges, setPendingChanges] = useState({});

    const ModelObj = {
        ToDate: new Date(),
        FromDate: new Date(),
        Type: '',
        Name: '',
        Url: '',
        Search: '',
        Criteria: 0,
        CriteriaText: '',
    };

    const selectData = async () => {
        setLoadingOpen(true);
        const response = await SELECT();
        setLoadingOpen(false);

        if (!response.isAuthorized) return LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        setItemList(JSON.parse(response.data));
        setPendingChanges({});
    };

    const handleToggleChange = (rowId, fieldName, currentValue) => {
        if (!rowId || !fieldName) {
            console.error("Invalid toggle action:", rowId, fieldName);
            return;
        }
        const newValue = !currentValue;

        setItemList(prevList =>
            prevList.map(item =>
                item.MainMenuID === rowId ? { ...item, [fieldName]: newValue } : item
            )
        );

        setPendingChanges(prev => ({
            ...prev,
            [rowId]: {
                ...(prev[rowId] || {}),
                [fieldName]: newValue,
            },
        }));
    };

    const UpdateClick = async (row) => { 
        const rowId = row[0];
        const rowChanges = pendingChanges[rowId] || {};

        let jsonObj = {
            MainMenuID: row[0],
            Name: row[1],
            Url: row[2],
            Sequence: row[3],
            IsAdmin: row[4],
            IsSuperDistributer: row[5],
            IsDistributer: row[6],
            IsRetailer: row[7],
            ISAPIUser: row[8],
            IsClient: row[9],
            IsSDFOS: row[10],
            IsDFOS: row[11],
            GUID: row[12],
            ...rowChanges
        };
        setLoadingOpen(true); 
        const { isAuthorized, status, data } = await UPDATE(JSON.stringify(jsonObj));
        setLoadingOpen(false);

        if (!isAuthorized) return LOGOUT();

        setSeverity(status ? 'success' : 'error');
        setResponseMessage(data);
        setIsError(true);

        if (status) {
            selectData();
            setPendingChanges(prev => {
                const updated = { ...prev };
                delete updated[rowId];
                return updated;
            });
        }
    };

    const createColumns = () => {
        const userTypes = [
            { label: 'IsAdmin', name: 'IsAdmin' },
            { label: 'IsSuperDistributer', name: 'IsSuperDistributer' },
            { label: 'IsDistributer', name: 'IsDistributer' },
            { label: 'IsRetailer', name: 'IsRetailer' },
            { label: 'IsAPIUser', name: 'ISAPIUser' },
            { label: 'IsClient', name: 'IsClient' },
            { label: 'IsSDFOS', name: 'IsSDFOS' },
            { label: 'IsDFOS', name: 'IsDFOS' }
        ];

        setMainColumns([
            { label: '#', name: 'MainMenuID', srno: true },
            { label: 'Name', name: 'Name' },
            { label: 'Url', name: 'Url' },
            { label: 'Sequence', name: 'MenuSequence' },
            ...userTypes.map(({ label, name }) => ({
                label,
                name,
                activate: true,
                editable: true,
                callback: (id, value, row) => {
                    if (!row || !row[name]) {
                        return;
                    }
                    handleToggleChange(id, name, row[name]);
                }
            })),
            { label: 'GUID', name: 'GUID', hide: true },
            { label: 'Update', name: 'Update', save: true, buttonTitle: 'Update', callback: (row) => UpdateClick(row) }
        ]);
    };


    useEffect(() => {
        createColumns();
        selectData();
    }, []);

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={setIsError}
        >
            <Formik enableReinitialize innerRef={formRef} initialValues={ModelObj} onSubmit={() => { }}>
                {() => (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <h2 className={classes.PaperHead_h2}>Main Menu Sub Menu User Access</h2>
                        </Grid>
                    </Grid>
                )}
            </Formik>

            <ReactTable data={itemList} columns={mainColumns} rowsPerPage={50} />
        </CustomContainer>
    );
};
